module.exports = __webpack_public_path__ + "assets/restricted-zone-violation-icon.png?9fdc221bd526e0ac433cc4e0281ead87";